import { useContext } from "react";
import { languageSkillsActionTypes } from "../reducer/resume-language-skills-reducer";
import { ResumeContext } from "../resume-context";

function useResumeLanguageSkillsHandlers() {
    const { dispatch } = useContext( ResumeContext );
    return {
        handleAdd: () => {
            dispatch( {
                type: languageSkillsActionTypes.ADD_LANGUAGE_SKILL,
                item: {
                    order: -1,
                    language: { code: null, translations: {} },
                    listeningComprehensionLevel: { code: null, translations: {} },
                    readingComprehensionLevel: { code: null, translations: {} },
                    continuousOralExpressionLevel: { code: null, translations: {} },
                    writingExpressionLevel: { code: null, translations: {} },
                    oralInteractionLevel: { code: null, translations: {} },
                },
            } );
        },
        handleChange: ( languageSkill ) => {
            dispatch( {
                type: languageSkillsActionTypes.CHANGE_LANGUAGE_SKILL,
                item: languageSkill,
            } );
        },
        handleRemove: ( languageSkill ) => {
            dispatch( {
                type: languageSkillsActionTypes.REMOVE_LANGUAGE_SKILL,
                item: languageSkill,
            } );
        },
        handleMoveUp: ( languageSkill ) => {
            dispatch( {
                type: languageSkillsActionTypes.MOVE_LANGUAGE_SKILL_UP,
                item: languageSkill,
            } );
        },
        handleMoveDown: ( languageSkill ) => {
            dispatch( {
                type: languageSkillsActionTypes.MOVE_LANGUAGE_SKILL_DOWN,
                item: languageSkill,
            } );
        },
    }
}

export default useResumeLanguageSkillsHandlers
